// Estilos inline compartilhados pelos sub-componentes de Comercial / Propostas.
// Extraído de ComercialPropostas.tsx durante refactor topológico.
import React from 'react';

export const labelMini: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 3 };
export const thMini: React.CSSProperties = { padding: '6px 8px', fontSize: 10, fontWeight: 600, textAlign: 'left', letterSpacing: '0.04em' };
export const tdMini: React.CSSProperties = { padding: '5px 8px', fontSize: 11 };
export const tdEditMini: React.CSSProperties = { padding: '3px 5px', fontSize: 11 };
export const inputSm: React.CSSProperties = { width: '100%', padding: '4px 6px', fontSize: 11, borderRadius: 3, border: '0.5px solid #ddd', boxSizing: 'border-box' };
export const inputBase: React.CSSProperties = { width: '100%', padding: '7px 10px', fontSize: 12, borderRadius: 5, border: '0.5px solid #ddd', boxSizing: 'border-box' };
export const lbl: React.CSSProperties = { display: 'block', fontSize: 10, color: '#666', marginBottom: 3, fontWeight: 600 };
// ─── styles ───
export const th: React.CSSProperties = { padding: '10px 10px', textAlign: 'left', fontSize: 11, fontWeight: 600, letterSpacing: '0.04em' };
export const td: React.CSSProperties = { padding: '8px 10px', fontSize: 12 };
export const btnAcao = (color: string): React.CSSProperties => ({
  fontSize: 10, padding: '3px 8px', borderRadius: 3, border: `0.5px solid ${color}`,
  background: '#fff', color, cursor: 'pointer', marginRight: 2, fontWeight: 500,
});
export const btnSec: React.CSSProperties = { padding: '8px 18px', fontSize: 12, border: '0.5px solid #ddd', borderRadius: 5, background: '#fff', cursor: 'pointer' };
export const btnPri: React.CSSProperties = { padding: '8px 22px', fontSize: 12, border: 'none', borderRadius: 5, background: '#0930D0', color: '#fff', cursor: 'pointer', fontWeight: 600 };
export const modalOverlay: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
export const modalContent: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 24, width: '92%', maxHeight: '92vh', overflow: 'auto',
};
export const labelStyle: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 4, display: 'block' };
export const inputStyle: React.CSSProperties = {
  width: '100%', padding: '7px 10px', fontSize: 12, borderRadius: 5,
  border: '0.5px solid #ddd', boxSizing: 'border-box',
};
